import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "src/async/apiUtils";
import Preloader from "src/components/shared/LoadingAnimations/Preloader";

const SubscriptionExpired = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const checkStatusAndNavigate = async () => {
    const token = localStorage.getItem("accessToken") || localStorage.getItem("refreshToken") || localStorage.getItem("access_token");
    try {
      const res = await apiRequest(
        "post",
        "/portal/users/self/details",
        {
          body: {
            id: localStorage.getItem("impersonatedUserId") || localStorage.getItem("userId"),
            token: localStorage.getItem("refreshToken"),
          },
        },
        { returnErrorWithstatus: true }
      );

      if (res?.status === 200 && res?.data?.status !== "client_inactive" && res?.data?.status !== "inactive") {
        if (token) {
          navigate("/");
        } else {
          navigate("/login");
        }
      }
    } catch (err) {
      // If API returns 403 or client_inactive error, stay on this page
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkStatusAndNavigate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await checkStatusAndNavigate();
    } finally {
      setTimeout(() => setIsRefreshing(false), 500);
    }
  };

  if (loading) {
    return (
      <div className="flex min-h-screen w-full items-center justify-center bg-white select-none">
        <Preloader />
      </div>
    );
  }

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-white px-4 py-12 text-center font-sans antialiased sm:px-6 lg:px-8 select-none">
      <div className="max-w-md space-y-4">
        <div className="space-y-2">
          <h1 className="text-2xl font-bold tracking-tight text-[#0f172a] sm:text-3xl">
            Your subscription has ended
          </h1>
          <p className="text-sm font-normal text-[#64748b] sm:text-base">
            Please contact administrator for more details
          </p>
        </div>

        <div className="pt-2">
          <button
            type="button"
            onClick={handleRefresh}
            disabled={isRefreshing}
            className="inline-flex items-center justify-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm transition-all hover:bg-gray-50 focus:outline-none disabled:opacity-50">
            <svg
              className={`h-4 w-4 text-gray-500 ${isRefreshing ? "animate-spin" : ""}`}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
            {isRefreshing ? "Refreshing..." : "Refresh"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionExpired;
